import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing } = redesignTheme;

export const useBreadcrumbsStyles = makeStyles(() => ({
  breadcrumbs: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 5,
  },
  breadcrumbsMarginSm: {
    marginBottom: spacing.sm,
  },
  breadcrumbsMarginMd: {
    marginBottom: spacing.md,
  },
  breadcrumbsMarginXs: {
    marginBottom: spacing.xs,
  },
  breadcrumbLink: {
    border: 0,
    padding: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
  },
  breadcrumbCurrent: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
  },
  breadcrumbIcon: {
    width: 16,
    height: 16,
    color: colors.text,
  },
}));
